import { ReactNode, useState, useEffect } from 'react';
import TrialBanner from './TrialBanner';
import QuickStartBanner from './QuickStartBanner';
import ReactivationModal from './ReactivationModal';
import { useBetaAccess } from '../hooks/useBetaAccess';

interface AuthenticatedLayoutProps {
  children: ReactNode;
}

export default function AuthenticatedLayout({ children }: AuthenticatedLayoutProps) {
  const { betaAccess } = useBetaAccess();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if banner should be shown (has beta access and not dismissed)
    const isDismissed = sessionStorage.getItem('betaBannerDismissed') === 'true';
    setShowBanner(betaAccess.hasActiveBeta && !isDismissed);
  }, [betaAccess.hasActiveBeta]);

  // Listen for banner dismissal
  useEffect(() => {
    const handleStorageChange = () => {
      const isDismissed = sessionStorage.getItem('betaBannerDismissed') === 'true';
      setShowBanner(betaAccess.hasActiveBeta && !isDismissed);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [betaAccess.hasActiveBeta]);

  return (
    <>
      <TrialBanner />
      <QuickStartBanner />
      <ReactivationModal />
      {/* Add a spacer div when banner is shown to push content down */}
      {showBanner && <div style={{ height: '52px' }} />}
      {children}
    </>
  );
}